export const sideNavbar = {
  home: "Inicio",
  games: "Juegos",
  allGames: "Juegos",
  lottery: "Lotería",
  raffle: "Rifa",
  providers: "Elige tu proveedor favorito",
  categories: "Categorias",
  casino: "Casino",
  casinos: "Casinos",
  sports: "Deportes",
  allSports: "Deportes",
  soccer: "Fútbol",
  baseball: "Beisbol",
  basketball: "Basket",
  e_sports: "E-Sports",
  nfl: "NFL",
  allPageSports: "Ir a Todos",
  allPageGames: "Ir a Todos",
  support: "Soporte",
  live_casino: "Casino en Vivo",
  bingo: "Bingo",
  horses: "Caballos",
  hipism: "Hipismo",
  News: "Noticias",
  gameFeed: "Feed de Juegos",
};
